export default __webpack_public_path__ + "static/media/404-landscape@2x.daee12ef.jpg";